<p-toast></p-toast>
<p-dialog
  [(visible)]="display"
  [style]="{ width: '35vw' }"
  (onHide)="cancel()"
  [modal]="true"
  id="trainingCompleteDateModal"
>
  <ng-template pTemplate="header"> Training Complete Date Selection </ng-template>
  <div *ngIf="errorMessages.length > 0" class="ErrorMessagePlaceHolder">
    <p-messages severity="error">
      <ng-template pTemplate>
        <div class="p-message-wrapper">
          <div>
            <ul>
              <li *ngFor="let errorText of errorMessages">
                {{ errorText }}
              </li>
            </ul>
          </div>
        </div>
      </ng-template>
    </p-messages>
  </div>
  <p>
    {{completeDateModalText}}
  </p>
  <div class="mt-2">
    <bpt-datetime
      appendTo="'body'"
      id="trainingCompleteDate"
      [required]="true"
      [maxDate]="maxDateValue.toString()"
      placeholder="Enter or select a date"
      label="Complete Date"
      [(ngModel)]="selectedCompleteDate"
    ></bpt-datetime>
  </div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="Confirm"
      type="submit"
      id="saveCompleteDate"
      class="align-right"
      (debounceClick)="saveDate(selectedCompleteDate)"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Cancel"
      type="submit"
      id="cancel"
      class="align-right"
      (debounceClick)="cancel()"
    >
    </p-button>
  </ng-template>
</p-dialog>
